import { render } from "./SymptomDetailsView.vue?vue&type=template&id=7918a558"
import script from "./SymptomDetailsView.vue?vue&type=script&lang=js"
export * from "./SymptomDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__